import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import menuStyles from '../NewMenu.js';
import '../../Input/index.js';
import '../../../icons/index.es.js';
import '../../../utils/index.js';
import useTranslation from '../../../utils/Translation/useTranslation.js';
import SearchIcon from '../../../icons/components/SearchIcon.js';
import Input from '../../Input/Input.js';

const MenuSearchBox = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    ...rest
  } = _ref;
  const {
    translate
  } = useTranslation();
  const searchText = translate('searchText');
  return /*#__PURE__*/React__default.createElement("div", {
    className: menuStyles.searchBox
  }, /*#__PURE__*/React__default.createElement(SearchIcon, {
    className: menuStyles.searchBoxIcon,
    "aria-hidden": "true"
  }), /*#__PURE__*/React__default.createElement(Input, _extends({
    ref: ref,
    role: "searchbox",
    "aria-label": searchText,
    placeholder: searchText,
    className: menuStyles.searchBoxInput,
    full: true
  }, rest)));
});

export { MenuSearchBox as default };
